import { all, fork } from 'redux-saga/effects';
import { coreSaga } from 'base/core/saga';
import { authSaga } from 'base/auth/saga';
import { updateProfileSaga } from 'pages/profile/components/profile-update/saga';
import { createSessionSaga } from 'pages/sessions/components/sessions-create/saga';
import { sessionSammarySaga } from 'pages/sessions/components/session-summary/saga';
import { schedulesSaga } from 'pages/schedules/saga';
import { groupsSaga } from 'pages/groups/saga';
import { mediaSaga } from 'pages/media-library/saga';
import { viewContentSaga } from 'base/common/add-content-modal/saga';
import { articleSaga } from 'pages/articles/saga';
import { mediaModalSaga } from 'base/common/media-modal/saga';
import { chatSaga } from 'pages/sessions/components/message-hub/saga';
import { directChatSaga } from 'pages/sessions/components/direct-chat-hub/saga';
import { viewFormsSaga } from 'pages/forms/saga';
import { usersSaga } from 'pages/users/saga';
import { reviewSaga } from 'pages/review/saga';
import { newsfeedsSaga } from 'pages/newsfeed/saga';

export default function* rootSaga() {
  yield all(
    [
      fork(coreSaga),
      fork(authSaga),
      fork(updateProfileSaga),
      fork(createSessionSaga),
      fork(viewContentSaga),
      fork(schedulesSaga),
      fork(sessionSammarySaga),
      fork(groupsSaga),
      fork(mediaSaga),
      fork(articleSaga),
      fork(mediaModalSaga),
      fork(chatSaga),
      fork(directChatSaga),
      fork(viewFormsSaga),
      fork(usersSaga),
      fork(reviewSaga),
      fork(newsfeedsSaga),
    ],
  );
}
